import api from '../../../services/service_pos'
// import Swal from 'sweetalert2'

export default {
  props: ['host'],
  data () {
    return {
      obj: {
        'shift_id': 0,
        'host_code': '',
        'description': '',
        'amount': '0'
      },
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      }
    }
  },
  methods: {
    checkAmount () {
      if (this.obj.amount === '') {
        this.obj.amount = 0
      }
    },
    ExportMoneyOnShitf () {
      this.obj.amount = parseFloat(this.obj.amount)
      if (this.obj.amount > 0) {
        this.obj.host_code = this.host.host_code
        this.obj.shift_id = this.host.id
        // alert(JSON.stringify(this.obj))
        this.$store.commit('Loading')
        api.ImportMoney(
          this.REST_URL,
          this.obj,
          this.header,
          result => {
            if (result.response === 'success') {
              $('#ToolModalm').modal('hide')
              $('body').on('hidden.bs.modal', '.modal', function () {
                $(this).removeData('bs.modal')
              })
              this.openCashBox(this.host)
              // Swal.fire({
              //   title: 'ทำการนำเงินเข้าเรียบร้อย',
              //   text: 'ทำการนำเงินเข้าเรียบร้อย ท่านต้องการพิมพ์ใบนำเงินเข้าหรือไม่ ?',
              //   icon: 'success',
              //   showCancelButton: true,
              //   confirmButtonColor: '#3085d6',
              //   cancelButtonColor: '#d33',
              //   confirmButtonText: 'พิมพ์',
              //   cancelButtonText: 'ไม่พิมพ์'
              // }).then((res) => {
              //   if (res.value) {
              // $('body').on('hidden.bs.modal', '.modal', function () {
              //   $(this).removeData('bs.modal')
              // })
              this.printSlip(result.data)
              //   } else {
              //     $('body').on('hidden.bs.modal', '.modal', function () {
              //       $(this).removeData('bs.modal')
              //     })
              //   }
              // })
            } else {
              $('body').on('hidden.bs.modal', '.modal', function () {
                $(this).removeData('bs.modal')
              })
              this.$notification['warning']({
                message: 'ทำการนำเงินเข้าไม่ได้',
                description: result.message
              })
            }
            this.$store.commit('Loading')
          },
          error => {
            alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
            $('body').on('hidden.bs.modal', '.modal', function () {
              $(this).removeData('bs.modal')
            })
            this.$store.commit('Loading')
          }
        )
      } else {
        this.alert_msg('warning', 'นำเงินเข้า', 'ยอดนำเงินเข้า ต้องมีค่ามากกว่า 0')
      }
    },
    printSlip (data) {
      this.$store.commit('Loading')
      var obj = {
        'printer_port': this.host.printer_port,
        'id': data.id,
        'host_code': this.host.host_code
      }
      api.slipIncome(this.REST_URL,
        this.header,
        obj,
        result => {
          if (result.response === 'success') {
            this.$notification['success']({
              message: 'พิมพ์ใบนำเงินเข้าสำเร็จ',
              description: result.message
            })
          } else {
            this.$notification['warning']({
              message: 'พิมพ์ใบนำเงินเข้าไม่ได้',
              description: result.message
            })
          }
          $('body').on('hidden.bs.modal', '.modal', function () {
            $(this).removeData('bs.modal')
          })
          this.$store.commit('Loading')
        },
        error => {
          this.$store.commit('Loading')
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    }
  },
  mounted () {
    $('#ToolModalm').on(
      'show.bs.modal',
      function () {
        this.obj = {
          'shift_id': 0,
          'host_code': '',
          'description': '',
          'amount': '0'
        }
      }.bind(this)
    )
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/pos/income_shift.js